module.exports = __webpack_public_path__ + "img/应用场景_直播场景首图.7bb5ae22.png";